import React from 'react';
import ReactDOM from 'react-dom/client';

class GwCalculator extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      inputValue: props.inputValue,
      inputName: props.inputName,
      inputLabel: props.inputLabel,
      inputReadonly: props.inputReadonly,
      cashTypes: {
        '0.01': 0,
        '0.02': 0,
        '0.05': 0,
        '0.10': 0,
        '0.20': 0,
        '0.50': 0,
        '1': 0,
        '2': 0,
        '5': 0,
        '10': 0,
        '20': 0,
        '50': 0,
        '100': 0,
        '200': 0,
        '500': 0
      }
    };
  }

  /**
   * Permet de formatter le numéro pour la base
   * @param {number} number - Numéro à formatter
   * @param {number} decimal - Nomre de décimales
   * @returns {number}
   */
  formatNumberForBase(number, decimal) {
    if (number === null) {
      return '-';
    }
  
    if (typeof decimal !== 'undefined') {
      if (decimal === 0) {
        number = parseFloat(number)
          .toFixed(0) + '';
      } else {
        number = parseFloat(number)
          .toFixed(decimal) + '';
      }
    } else {
      number = parseFloat(number)
        .toFixed(2) + '';
    }
  
    return parseFloat(number);
  }

  /**
   * Lors du changement dans l'input texte
   * @param {PointerEvent} e - Événement associé au changement dans l'input
   */
  changeOnTargetInput(e) {
    this.setState({
      inputValue: e.target.value
    });
  }

  /**
   * Lors du changement dans l'input du type de monaie
   * @param {string} cashType - Type de monaie
   * @param {PointerEvent} e - Événement associé au changement dans l'input du type de monaie
   */
  changeOnCalculatorInput(cashType, e) {
    var updatedCashTypes = this.state.cashTypes,
        value = e.target.value;

    updatedCashTypes[cashType] = (value) ? parseInt(value, 10) : 0;

    this.setState({
      cashTypes: updatedCashTypes,
      inputValue: this.calculAmountWithCashTypes()
    });
  }

  /**
   * Calcul du prix par rapport au quantité de monaie saisie
   * @returns {number} Le prix calculé
   */
  calculAmountWithCashTypes() {
    var amount = _.reduce(this.state.cashTypes, (amount, cashType, index) => {
      var value = parseFloat(index);
      amount += value * cashType;
      return amount;
    }, 0);
    return this.formatNumberForBase(amount);
  }

  render() {
    return (
      <div>
        <div className="input-group">
          <label htmlFor="targetInput" className="input-group__label">* {this.state.inputLabel}</label>
          <input type="number" data-type="number" step="0.10" id="targetInput" name={this.state.inputName} className="input-group__input" readOnly={this.state.inputReadonly} value={this.state.inputValue} onChange={this.changeOnTargetInput.bind(this)}/>
        </div>
        <div className="grid grid--8-gap grid--has-8-child">
          <div className="input-group input-group--no-margin">
            <label htmlFor="oneCts" className="input-group__label">0,01 c€</label>
            <input type="number" data-type="number" step="0" id="oneCts" name="calculator[oneCts]" className="input-group__input" readOnly={this.state.inputReadonly} onChange={this.changeOnCalculatorInput.bind(this, '0.01')}/>
          </div>
          <div className="input-group input-group--no-margin">
            <label htmlFor="twoCts" className="input-group__label">0,02 c€</label>
            <input type="number" data-type="number" step="0" id="twoCts" name="calculator[twoCts]" className="input-group__input" readOnly={this.state.inputReadonly} onChange={this.changeOnCalculatorInput.bind(this, '0.02')}/>
          </div>
          <div className="input-group input-group--no-margin">
            <label htmlFor="fiveCts" className="input-group__label">0,05 c€</label>
            <input type="number" data-type="number" step="0" id="fiveCts" name="calculator[fiveCts]" className="input-group__input" readOnly={this.state.inputReadonly} onChange={this.changeOnCalculatorInput.bind(this, '0.05')}/>
          </div>
          <div className="input-group input-group--no-margin">
            <label htmlFor="tenCts" className="input-group__label">0,10 c€</label>
            <input type="number" data-type="number" step="0" id="tenCts" name="calculator[tenCts]" className="input-group__input" readOnly={this.state.inputReadonly} onChange={this.changeOnCalculatorInput.bind(this, '0.10')}/>
          </div>
          <div className="input-group input-group--no-margin">
            <label htmlFor="twenCts" className="input-group__label">0,20 c€</label>
            <input type="number" data-type="number" step="0" id="twenCts" name="calculator[twenCts]" className="input-group__input" readOnly={this.state.inputReadonly} onChange={this.changeOnCalculatorInput.bind(this, '0.20')}/>
          </div>
          <div className="input-group input-group--no-margin">
            <label htmlFor="fiftyCts" className="input-group__label">0,50 c€</label>
            <input type="number" data-type="number" step="0" id="fiftyCts" name="calculator[fiftyCts]" className="input-group__input" readOnly={this.state.inputReadonly} onChange={this.changeOnCalculatorInput.bind(this, '0.50')}/>
          </div>
          <div className="input-group input-group--no-margin">
            <label htmlFor="oneEuro" className="input-group__label">1 €</label>
            <input type="number" data-type="number" step="0" id="oneEuro" name="calculator[oneEuro]" className="input-group__input" readOnly={this.state.inputReadonly} onChange={this.changeOnCalculatorInput.bind(this, '1')}/>
          </div>
          <div className="input-group input-group--no-margin">
            <label htmlFor="twoEuros" className="input-group__label">2 €</label>
            <input type="number" data-type="number" step="0" id="twoEuros" name="calculator[twoEuros]" className="input-group__input" readOnly={this.state.inputReadonly} onChange={this.changeOnCalculatorInput.bind(this, '2')}/>
          </div>
          <div className="input-group input-group--no-margin">
            <label htmlFor="fiveEuros" className="input-group__label">5€</label>
            <input type="number" data-type="number" step="0" id="fiveEuros" name="calculator[fiveEuros]" className="input-group__input" readOnly={this.state.inputReadonly} onChange={this.changeOnCalculatorInput.bind(this, '5')}/>
          </div>
          <div className="input-group input-group--no-margin">
            <label htmlFor="tenEuros" className="input-group__label">10 €</label>
            <input type="number" data-type="number" step="0" id="tenEuros" name="calculator[tenEuros]" className="input-group__input" readOnly={this.state.inputReadonly} onChange={this.changeOnCalculatorInput.bind(this, '10')}/>
          </div>
          <div className="input-group input-group--no-margin">
            <label htmlFor="twentyEuros" className="input-group__label">20 €</label>
            <input type="number" data-type="number" step="0" id="twentyEuros" name="calculator[twentyEuros]" className="input-group__input" readOnly={this.state.inputReadonly} onChange={this.changeOnCalculatorInput.bind(this, '20')}/>
          </div>
          <div className="input-group input-group--no-margin">
            <label htmlFor="fiftyEuros" className="input-group__label">50 €</label>
            <input type="number" data-type="number" step="0" id="fiftyEuros" name="calculator[fiftyEuros]" className="input-group__input" readOnly={this.state.inputReadonly} onChange={this.changeOnCalculatorInput.bind(this, '50')}/>
          </div>
          <div className="input-group input-group--no-margin">
            <label htmlFor="oneHundredEuros" className="input-group__label">100 €</label>
            <input type="number" data-type="number" step="0" id="oneHundredEuros" name="calculator[oneHundredEuros]" className="input-group__input" readOnly={this.state.inputReadonly} onChange={this.changeOnCalculatorInput.bind(this, '100')}/>
          </div>
          <div className="input-group input-group--no-margin">
            <label htmlFor="twoHundredEuros" className="input-group__label">200 €</label>
            <input type="number" data-type="number" step="0" id="twoHundredEuros" name="calculator[twoHundredEuros]" className="input-group__input" readOnly={this.state.inputReadonly} onChange={this.changeOnCalculatorInput.bind(this, '200')}/>
          </div>
          <div className="input-group input-group--no-margin">
            <label htmlFor="fiveHundredEuros" className="input-group__label">500 €</label>
            <input type="number" data-type="number" step="0" id="fiveHundredEuros" name="calculator[fiveHundredEuros]" className="input-group__input" readOnly={this.state.inputReadonly} onChange={this.changeOnCalculatorInput.bind(this, '500')}/>
          </div>
        </div>
      </div>
    );
  }
}

var calculatorNodes = document.getElementsByClassName('gw-calculator');
Array.prototype.forEach.call(calculatorNodes, function(calculatorNode) {
  var root = ReactDOM.createRoot(calculatorNode),
      dataInputReadonly = calculatorNode.getAttribute('data-input-readonly'),
      readOnly = false;

  if(dataInputReadonly) {
    readOnly = (dataInputReadonly === 'true') ? true : false;
  }

  root.render(
    <GwCalculator 
      inputValue={calculatorNode.getAttribute('data-input-value') || ''}
      inputName={calculatorNode.getAttribute('data-input-name')}
      inputLabel={calculatorNode.getAttribute('data-input-label')}
      inputReadonly={readOnly}
    />
  );
});
